import React from 'react';
import "./TriyoButton.scss"

const TriyoButton = (props) => {
    const { children } = props;
    return (
        <div className='table-buttons-container'>
            {children}
        </div>
    );
}

export default TriyoButton;